import { Tooltip, styled, tooltipClasses } from "@mui/material";

const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
	({ theme }) => ({
		[`& .${tooltipClasses.tooltip}`]: {
			backgroundColor: "#fff",
			color: "#000",
			maxWidth: 300,
			border: "1px solid #dadde9",
		},
	})
);

export default HtmlTooltip;
